export type Progress = { status: "progress"; data: FileProgressLoaderProps };

export type ResultWithProgress<T> =
  | {
      status: "error";
      err: Error;
    }
  | { status: "done"; data: T }
  | Progress;

export function isProgress(r: ResultWithProgress<any>): r is Progress {
  return r.status === "progress";
}

export interface FileProgressLoaderProps {
  direction: "upload" | "download";
  percent?: number;
  total?: number;
  loaded: number;
}
